import api from './api';
import { CONTENT_EXTRACTION_PUBSUB_NEGOTIATE } from '../configs/routes';

/**
 * Negotiate a Web PubSub client access URL (token already embedded in query string).
 * @returns {Promise<{ url: string }>}
 */
export const negotiatePubSub = () =>
    api.get(CONTENT_EXTRACTION_PUBSUB_NEGOTIATE).then((res) => res.data);
